import { inject, provideAppInitializer } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore, Store } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { filter, take } from 'rxjs/operators';
import { SessionActions, SessionEffects, SessionReducer } from '@app/core/state/session';
import { CompaniesEffects, CompaniesReducer } from '@app/core/state/companies';
import { PayrollClosesEffects, PayrollClosesReducer } from '@app/core/state/payroll-closes';
import { AuthEffects, AuthReducer } from '@app/core/state/auth';
import { environment } from '../../environments/environment';

interface SessionBootstrapState {
  session: {
    profileFetchDone: boolean;
    companiesFetchDone: boolean;
    error: unknown;
  };
}

function initApplication(store: Store<SessionBootstrapState>) {
  return () =>
    new Promise((resolve) => {
      store.dispatch(SessionActions.getProfile());
      store.dispatch(SessionActions.getUserCompaniesToHandle());
      store
        .select('session')
        .pipe(
          filter(
            (session) =>
              (session.companiesFetchDone && session.profileFetchDone) || Boolean(session.error),
          ),
          take(1),
        )
        .subscribe(() => resolve(true));
    });
}

export const storeProviders = [
  provideStore(),
  provideState('session', SessionReducer),
  provideState('auth', AuthReducer),
  provideState('companies', CompaniesReducer),
  provideState('payrollCloses', PayrollClosesReducer),
  provideEffects([SessionEffects, AuthEffects, CompaniesEffects, PayrollClosesEffects]),
  ...(environment.storeDevtools ? [provideStoreDevtools(environment.storeDevtools)] : []),
  provideAppInitializer(() => {
    const store = inject(Store<SessionBootstrapState>);
    return initApplication(store)();
  }),
];
